<div class="d-table w-100">
    <span class="float-start d-block d-md-none"><button *ngIf="currentTab !== 'AddDocuments'" class="btn btn-sm btn-outline-primary mt-4 me-2" (click)="previous();" translate>Button.Previous</button></span>
    <span class="float-end">
        <button *ngIf="!enableSendRequestAction" [disabled]="disableNextButton()" class="btn btn-sm btn-primary mt-4" (click)="next();" translate>Button.Next</button>
        <button *ngIf="enableSendRequestAction" class="btn btn-sm btn-success mt-4" (click)="send()" translate>Button.SendRequest</button>
    </span>
</div>